import { APIKEY, CONTENTTYPE } from "./parameters.js";

const Headers = () => {
  const headers = {
    "X-MICROCMS-API-KEY": APIKEY,
    "Content-Type": CONTENTTYPE,
  };
  return headers;
};

export { Headers };
